// el('div.name', { id: 'x', onclick: fn }, 'text', child, ...)
export function el(spec, attrs, ...children) {
  const [tag, ...classes] = spec.split('.');
  const node = document.createElement(tag || 'div');
  if (classes.length) node.className = classes.join(' ');
  if (attrs) {
    for (const key of Object.keys(attrs)) {
      const v = attrs[key];
      if (v === undefined || v === null || v === false) continue;
      if (key.startsWith('on')) node.addEventListener(key.slice(2), v);
      else if (key === 'style') node.style.cssText = v;
      else if (key === 'hidden' || key === 'disabled') node[key] = !!v;
      else if (key === 'class' || key === 'className') node.className = node.className ? `${node.className} ${v}` : String(v);
      else node.setAttribute(key, v === true ? '' : v);
    }
  }
  append(node, children);
  return node;
}

export function append(node, children) {
  for (const c of children) {
    if (c === null || c === undefined || c === false) continue;
    if (Array.isArray(c)) append(node, c);
    else node.appendChild(typeof c === 'object' ? c : document.createTextNode(String(c)));
  }
}

export function clear(node) {
  while (node.firstChild) node.removeChild(node.firstChild);
}
